module.exports = __webpack_public_path__ + "static/media/studyGroup.c942fa4c.png";